import { render } from "./GroupUserExample.vue?vue&type=template&id=58e6cab6&ts=true"
import script from "./GroupUserExample.vue?vue&type=script&lang=ts"
export * from "./GroupUserExample.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__